import React, {ReactElement} from "react";
import {Helmet} from "react-helmet";
import {ImageDataLike, getSrc} from "gatsby-plugin-image";
import {ImageObject} from "../image/Image";

export interface HeaderInfoProps {
  title: string;
  description?: string;
  image?: string | ImageObject;
  noindexNofollow?: boolean;
}

const HeaderInfo = (props: HeaderInfoProps): ReactElement => {
  const {title, description, image, noindexNofollow} = props;

  const noIndexing = noindexNofollow === true;

  let imageSrc = image;

  if (image && typeof image !== "string") {
    imageSrc = getSrc(image.gatsbyImageData as ImageDataLike);
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      {description && <meta name="description" content={description} />}

      {/* disable indexing if needed */}
      {noIndexing && <meta name="robots" content="noindex, follow" />}

      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {imageSrc && (
        <meta name="image" property="og:image" content={imageSrc as string} />
      )}
      {/* <meta property="og:url"> tag is added at build time (see gatsby-ssr.js) */}

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {imageSrc && <meta name="twitter:image" content={imageSrc as string} />}

      <meta name="twitter:site" content="@flexport" />
      {/* hrefLang tags are added at build time (see gatsby-ssr.js) */}

      <meta
        name="google-site-verification"
        content="ljB2dlwAJSzqyUIygIKpx7VyYYEooJVo0Ubr_nZm31E"
      />
    </Helmet>
  );
};

export default HeaderInfo;
